<template>
  <div id="addon-port-master-destination-work-list">
    <div class="flex pm-destination-work-top">
      <div class="flex w-1/2 justify-start">
        <span class="pm-current-time">{{ dispDate }}</span>
        <vs-chip  color="#4f4f4f" class="pm-display-date" :class="[ display1Active ? classNameCursorPointer : null ]" >
          <span v-if="display1Active"  @mousedown="showPopupDate = true" >{{ displayDateList.find(displayDate => displayDate.id === selectedDateDisplay1).name }}</span>
          <span v-else-if="display2Active" >当日</span>
          <span v-else-if="display3Active && !showTomorrow" >当日</span>
          <span v-else-if="display3Active &&  showTomorrow" >翌日</span>
        </vs-chip>
        <vs-popup
          :active.sync="showPopupDate"
          class="pm-display-date-popup"
          :id="'display_date_popup'"
          title="日付"
        >
          <div class="flex justify-center outer-area">
            <div class="vs-col pm-display-date-item" v-for="(displayDate,index) in displayDateList" :key="index" >
              <vs-button
                :color="(selectedDisplayDateId === displayDate.id) ? '#346c88' : '#828282' "
                @mousedown="selectedDisplayDateId = displayDate.id"
              >
                {{ displayDate.name }}
              </vs-button>
            </div>
          </div>
          <div class="flex justify-center">
            <vs-button
              color="#2d9cdb"
              class="save-button"
              @mousedown="onChangeDate"
            >保存</vs-button>
          </div>

        </vs-popup>

      </div>
      <div class="flex w-1/2 justify-end">
          <div id="vessel-header" class="pm-click-jacking" @mousedown="toggleVesselNameJapaneseFlg" ></div>
          <div id="pilot-header"  class="pm-click-jacking" @mousedown="togglePilotColorFlg"         ></div>


          <div class="flex justify-start pm-filter-control" style="color: #bdbdbd;">
            <span>
              <span class="last-updated-text">最終更新：{{ lastUpdatedTime }}</span>
            </span>
          </div>

          <div class="flex justify-start pm-filter-control" @mousedown="reconnectToServer" :style="{ color: (onReconnect ? '#828282' : '#bdbdbd' )}" :class="[ classNameCursorPointer ]">
            <span>
              <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" style="margin:0 0.2rem;" />
              <span>画面再読込み</span>
            </span>
          </div>
          <div class="flex justify-start pm-filter-control" @mousedown="onScrollUnlock" v-show="display1Active" :class="[ classNameCursorPointer ]">
            <span>
              <img :src=" !scrollUnlock ? scrollDefaultIconUrl : scrollSelectedIconUrl " style="width:1rem;height:1rem;margin:0 0.2rem;" />
              <span :style="{ color: !scrollUnlock ? '#bdbdbd' : '#2d9cdb' }" >スクロール</span>
            </span>
          </div>
          <div  class="flex justify-end" @mousedown="onChangeActiveListFlg" v-show="display1Active" :class="[ classNameCursorPointer ]">
            <div style="padding:0.3rem 2.6rem 0.3rem 0.2rem;background-color:#4f4f4f; margin: 0 0 0.5rem 0.5rem;border-radius:0.2rem;">
              <div v-if="activeListFlg" >
                <img :src="finishedCheckIconUrl" style="width:1rem;height:1rem;margin:0 0.6rem;padding-top:0.2rem;" />
                <span style="color: #f2f2f2;'}" >終了</span>
              </div>
              <div v-else >
                <img :src="finishedBackIconUrl" style="width:1rem;height:1rem;margin:0 0.6rem;padding-top:0.2rem;" />
                <span style="color: #f2f2f2;}" >戻る</span>
              </div>
            </div>
          </div>
      </div>
    </div>

    <div v-show="display1Active">

      <ag-grid-vue
        ref="agGridTable1"
        :rowData="destinationWorkTasks"
        :gridOptions="gridOptions1"
        :columnDefs="columnDefs1"
        :defaultColDef="defaultColDef"
        :components="components"
        rowSelection="multiple"
        colResizeDefault="shift"
        :floatingFilter="false"
        :enableRtl="$vs.rtl"
        :rowDragManaged="true"
        :animateRows="false"
        :suppressHorizontalScroll="true"
        @grid-size-changed="onGridSizeChangedFromAgGrid"
        class="ag-theme-material ag-grid-table pm-ag-grid-vue"
        :class="[ isReadOnlyDevice === true ? 'pm-ag-grid-vue-ipad-width' : null ]"
      >
      </ag-grid-vue>

      <cell-summary-dialog
        :showPopup.sync="showPopupSync"
        :clickX="clickX"
        :clickY="clickY"
        :popupTitle="popupTitle"
        :popupTaskId="popupTaskId"
        :popupColumnKey="popupColumnKey"
        :popupValueMap="popupValueMap"
        @updateGridCell="updateGridCell"
      />

    </div>
    <div v-show="display2Active">

      <div class="flex">
        <div :class="display2split === 1 ? 'w-full' : 'w-1/2'">
          <ag-grid-vue
            ref="agGridTable2a"
            :rowData="destinationWorkTasks2a"
            :columnDefs="columnDefs2a"
            :gridOptions="gridOptions2a"
            :defaultColDef="defaultColDef"
            :components="components"
            :suppressHorizontalScroll="true"
            @grid-size-changed="onGridSizeChangedFromAgGrid"
            class="ag-theme-material ag-grid-table pm-ag-grid-vue"
            :class="[ display2split >= 2 ? 'pm-ag-grid-vue-div2' : null ]"
          />
        </div>
        <div v-if="display2split >= 2" class="w-1/2">
          <ag-grid-vue
            ref="agGridTable2b"
            :rowData="destinationWorkTasks2b"
            :columnDefs="columnDefs2b"
            :gridOptions="gridOptions2b"
            :defaultColDef="defaultColDef"
            :components="components"
            :suppressHorizontalScroll="true"
            @grid-size-changed="onGridSizeChangedFromAgGrid"
            class="ag-theme-material ag-grid-table pm-ag-grid-vue"
            :class="[ display2split >= 2 ? 'pm-ag-grid-vue-div2' : null ]"
          />
        </div>
      </div>
    </div>
    <div v-show="display3Active">

      <div class="flex">
        <div :class="display3split === 1 ? 'w-full' : 'w-1/2'">
          <ag-grid-vue
            ref="agGridTable3a"
            :rowData="destinationWorkTasks3a"
            :columnDefs="columnDefs3a"
            :gridOptions="gridOptions3a"
            :defaultColDef="defaultColDef"
            :components="components"
            :suppressHorizontalScroll="true"
            @grid-size-changed="onGridSizeChangedFromAgGrid"
            class="ag-theme-material ag-grid-table pm-ag-grid-vue"
            :class="[ display3split >= 2 ? 'pm-ag-grid-vue-div2' : null ]"
          />
        </div>
        <div v-if="display3split >= 2" class="w-1/2">
          <ag-grid-vue
            ref="agGridTable3b"
            :rowData="destinationWorkTasks3b"
            :columnDefs="columnDefs3b"
            :gridOptions="gridOptions3b"
            :defaultColDef="defaultColDef"
            :components="components"
            :suppressHorizontalScroll="true"
            @grid-size-changed="onGridSizeChangedFromAgGrid"
            class="ag-theme-material ag-grid-table pm-ag-grid-vue"
            :class="[ display3split >= 2 ? 'pm-ag-grid-vue-div2' : null ]"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import moment from "moment-timezone";
import CellRendererItem from "./components/CellRendererItem";
import CellSummaryDialog from "./components/CellSummaryDialog";
import { AgGridVue } from "ag-grid-vue";
import authService from "@/services/authService";
import _ from 'lodash';
import { DeviceInfoMixin } from "@/mixins";
import Vue from "vue";
import FireStoreService from "@/services/fireStoreService";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("portMasterDestinationWork");
const { mapState: mapStateOfPortMaster } = createNamespacedHelpers("portMaster");


export default {
  components: {
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererItem,
    CellSummaryDialog,
  },
  mixins: [DeviceInfoMixin],
  data() {
    return {
      isReady: false,
      pageLoadTime: 0,
      dispDate: "",
      displayDateList: [
        { id: "today",            name: "当日" },
        { id: "tomorrow",         name: "翌日" },
        { id: "dayAfterTomorrow", name: "翌々日" },
      ],
      selectedDisplayDateId: "today",
      showTomorrow: true,
      display1Active: false,
      display2Active: false,
      display3Active: false,
      destinationWorkTasks: [],
      filteredDestinationWorkTasks: [],
      activeListFlg: true,
      scrollUnlock: false,
      lastUpdate: 0,
      showPopupDate: false,
      display2split: 2,
      display3split: 2,
      sizeRate: -1,
      pmAgGridWidth: -1,
      grabbedRowIndex: null,

      clickX: -1,
      clickY: -1,
      popupTitle: "",
      popupTaskId: "",
      popupColumnKey: "",
      popupValueMap: null,
      onReconnect: false,
      isReadOnlyDevice: false,
      isReadOnlyAccount: false,

      // AgGrid-common
      components: {CellRendererItem},
      defaultColDef: {
        sortable: false,
        resizable: false,
        suppressMenu: true,
      },

      // AgGrid1
      gridApi1: null,
      columnDefs1: [],
      destinationWorkTasks1: [],
      gridOptions1: {
        localeText: { noRowsToShow: "入出港情報を取得中です。" },
        context: { componentParent: this },
        suppressCellSelection: true,
        onRowDragMove: this.onRowDragMove,
        onRowDragEnd: this.onRowDragEnd,
        onCellMouseDown: this.onCellClicked,
        suppressMoveWhenRowDragging: true,
        rowBuffer: 125,
      },

      // AgGrid 2a,2b,3a,3b
      gridApi2a: null,
      columnDefs2a: [],
      destinationWorkTasks2a: [],
      gridOptions2a: {
        localeText: { noRowsToShow: "入出港情報を取得中です。" },
        context: { componentParent: this },
        suppressCellSelection: true,
      },

      gridApi2b: null,
      columnDefs2b: [],
      destinationWorkTasks2b: [],
      gridOptions2b: {
        localeText: { noRowsToShow: "--" },
        context: { componentParent: this },
        suppressCellSelection: true,
      },

      gridApi3a: null,
      columnDefs3a: [],
      destinationWorkTasks3a: [],
      gridOptions3a: {
        localeText: { noRowsToShow: "入出港情報を取得中です。" },
        context: { componentParent: this },
        suppressCellSelection: true,
      },

      gridApi3b: null,
      columnDefs3b: [],
      destinationWorkTasks3b: [],
      gridOptions3b: {
        localeText: { noRowsToShow: "--" },
        context: { componentParent: this },
        suppressCellSelection: true,
      },


      scrollDefaultIconUrl: require("@/assets/images/icons/port-master/scroll_default.svg"),
      scrollSelectedIconUrl: require("@/assets/images/icons/port-master/scroll_selected.svg"),
      finishedCheckIconUrl: require("@/assets/images/icons/port-master/finished_check.svg"),
      finishedBackIconUrl: require("@/assets/images/icons/port-master/finished_back.svg"),
    };
  },
  watch: {
    lastUpdatedForTasks() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.redrawGrid();
          this.isReady = true;
          this.pageLoadTime = moment().valueOf();
          this.$vs.loading.close();
        }, 1200);
      });
    },
    lastUpdatedForColumns() {
      if ( this.isReady ) {
        this.lastUpdate = moment().valueOf();
        this.redrawGrid();
        this.onGridSizeChanged();
      }
    },
    lastUpdatedForMonitors() {
      if ( this.isReady ) {
        this.lastUpdate = moment().valueOf();
        this.redrawGrid();
        this.onGridSizeChanged();
      }
    },
    lastUpdatedForMasters() {
      if ( this.isReady ) {
        this.lastUpdate = moment().valueOf();
        this.redrawGrid();
      }
    },
    selectedDateDisplay1() {
      this.redrawGrid();
    },
    display1Active() {
      this.bindGridApi();
    },
    display2Active() {
      this.bindGridApi();
    },
    display3Active() {
      this.bindGridApi();
    },
    destinationWorkHeaders() {
      // FireStoreのcolumn定義変更を検知したら、ag-grid-vueのcolumnDefsを更新
      this.refreshColumnDefs();
    },
    onChangeWindowSize() {
      this.onGridSizeChanged();
    },
  },
  computed: {
    ...mapState({
      destinationWorkHeaders:  state => state.destinationWorkHeaders,
      destinationWorkTasksMap: state => state.destinationWorkTasksMap,
      lastUpdatedForTasks:     state => state.lastUpdatedForTasks,
      lastUpdatedForColumns:   state => state.lastUpdatedForColumns,
      lastUpdatedForMonitors:  state => state.lastUpdatedForMonitors,
      lastUpdatedForMasters:   state => state.lastUpdatedForMasters,
      monitorSettingMap:       state => state.monitorSettingMap,
      selectedDateDisplay1:    state => state.selectedDateDisplay1,
      vesselNameJapaneseFlg:   state => state.vesselNameJapaneseFlg,
      pilotColorFlg:           state => state.pilotColorFlg,
      displayDates:            state => state.displayDates,
      selectedTaskId:          state => state.selectedTaskId,
      selectedColumnKey:       state => state.selectedColumnKey,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
      lastUpdatedTimeMap:      state => state.lastUpdatedTimeMap,
      displayNum:              state => state.setDisplayNum,
    }),
    ...mapStateOfPortMaster({
      selectedPort: state => state.selectedPort,
    }),
    filteredColumnDefs() {
      // display2,3で表示する列だけを抽出
      const filterColumns = ["order_type", "order_at", "previous", "berth", "head_count", "vessel", "bit", "flag", "boardside_type"];
      return JSON.parse(JSON.stringify(this.columnDefs1.filter(header => filterColumns.includes(header.field))));
    },
    lastUpdatedTime() {
      if ( this.display3Active === true ) {
        let showTomorrow = false;
        if ( this.monitorSettingMap[3] ) {
          // change_interval_time
          const changeIntervalYmdhms = this.displayDates.today.slice(0,4) + '-' + this.displayDates.today.slice(4,6) + '-' + this.displayDates.today.slice(6,8) + 'T' + this.monitorSettingMap[3].change_interval_time;
          const nowYmdhms            = this.displayDates.today.slice(0,4) + '-' + this.displayDates.today.slice(4,6) + '-' + this.displayDates.today.slice(6,8) + 'T' + moment().format("HH:mm:ss");
          showTomorrow = moment(changeIntervalYmdhms).valueOf() <  moment(nowYmdhms).valueOf();
        }
        return showTomorrow ? this.lastUpdatedTimeMap[this.displayDates.tomorrow] : this.lastUpdatedTimeMap[this.displayDates.today] ;
      } else if ( this.display2Active === true ) {
        return this.lastUpdatedTimeMap[this.displayDates.today];
      } else {
        return this.lastUpdatedTimeMap[this.displayDates[this.selectedDateDisplay1]];
      }
    },
    classNameCursorPointer() {
      let needCursorPointer = true;
      return needCursorPointer ? 'pm-cursor-pointer' : null;
    },
    showPopupSync: {
      get() {
        return this.summaryDialogShowPopup;
      },
      set(val) {
        this.setSummaryDialogShowPopup(val);
      }
    },
  },
  methods: {
    ...mapActions([
      "subscribeDestinationWorkTasks", "subscribeEventUpdate", "updateFirestoreDocument", "unsubscribeFirestore",
      "setTargetDates", "setSelectedDateDisplay1",  "setVesselNameJapaneseFlg",
      "fetchColumnsFromFirestore", "setPilotColorFlg", "setSelectedCell", "mergeUpdateDataIntoTaskRecord", "setSummaryDialogShowPopup", "setDisplayNum",
    ]),
    redrawGrid(){

      // Display1は 当日(or翌日or翌々日)の全件。

      if ( ! this.monitorSettingMap[1] ) {
        return;
      }

      const targetDateStr = this.selectedDateDisplay1;
      let dispTaskList = [];
      const destinationWorkTasks =  this.destinationWorkTasksMap[this.displayDates[targetDateStr]];
      if (destinationWorkTasks) {

        for( let taskId of Object.keys(destinationWorkTasks) ){
          let dispTask = destinationWorkTasks[taskId];

          let isTarget = !dispTask.progress.valueMap ?
            false :
            this.activeListFlg ?
              dispTask.progress.valueMap.id !== '4' :
              dispTask.progress.valueMap.id === '4' ;

          if ( isTarget ) {
            dispTask.id = taskId;
            dispTaskList.push(Object.assign({},dispTask));
          }
        }
      }
      dispTaskList.sort((a, b) => {
        // sort_orderでソート
        let comparison = 0;
        if (a.sort_order.valueMap.value > b.sort_order.valueMap.value) {
          comparison = 1;
        } else if (a.sort_order.valueMap.value < b.sort_order.valueMap.value) {
          comparison = -1;
        } else {
          // 第２ソートは オーダー時間
          if ( a.order_at.valueMap.value > b.order_at.valueMap.value ) {
            comparison = 1;
          } else if ( a.order_at.valueMap.value < b.order_at.valueMap.value ) {
            comparison = -1;
          }
        }
        return comparison ;
      });

      const display1From = this.monitorSettingMap[1].offset -1 ;
      const display1To   = display1From + this.monitorSettingMap[1].limit;

      // ag-grid-vue1 に一括セット
      const newDestinationWorkTasks = this.scrollUnlock ?
                                      dispTaskList.slice(display1From):
                                      dispTaskList.slice(display1From, display1To);

      this.setDestinationWorkTasks(this.gridOptions1.api, newDestinationWorkTasks);

      // grid1 データ表示リロード
      if ( this.gridApi1 ) {
        this.gridApi1.refreshCells({ force: true, suppressFlash: true, });
        this.$nextTick(() => {
          this.onGridSizeChanged();
        });
      }

      // 2ページ目、３ページ目のフィルタ

      const display2aFrom = this.monitorSettingMap[2].offset -1 ;
      const display2aTo   = display2aFrom + Math.floor( this.monitorSettingMap[2].limit / this.display2split);
      const display2bFrom = display2aTo ;
      const display2bTo   = display2bFrom + Math.floor( this.monitorSettingMap[2].limit / this.display2split );

      this.setDestinationWorkTasks(this.gridOptions2a.api, dispTaskList.slice(display2aFrom,display2aTo));
      if ( this.gridApi2a ) {
        this.gridApi2a.refreshCells({  force: true,  suppressFlash: true,});
        this.$nextTick(() => {
          this.onGridSizeChanged();
        });
      }

      this.setDestinationWorkTasks(this.gridOptions2b.api, dispTaskList.slice(display2bFrom,display2bTo));
      if ( this.gridApi2b ) {
        this.gridApi2b.refreshCells({  force: true,  suppressFlash: true,});
        this.$nextTick(() => {
          this.onGridSizeChanged();
        });
      }


      this.display2split = this.getDisplay2split();
      this.display3split = this.getDisplay3split();

      // change_interval_time
      const changeIntervalYmdhms = this.displayDates.today.slice(0,4) + '-' + this.displayDates.today.slice(4,6) + '-' + this.displayDates.today.slice(6,8) + 'T' + this.monitorSettingMap[3].change_interval_time;
      const nowYmdhms            = this.displayDates.today.slice(0,4) + '-' + this.displayDates.today.slice(4,6) + '-' + this.displayDates.today.slice(6,8) + 'T' + moment().format("HH:mm:ss");
      this.showTomorrow = moment(changeIntervalYmdhms).valueOf() <  moment(nowYmdhms).valueOf();

      const display3aFrom = this.showTomorrow ? 0 : this.monitorSettingMap[3].offset -1 ;
      const display3aTo   = display3aFrom + Math.floor( this.monitorSettingMap[3].limit / this.display3split);
      const display3bFrom = display3aTo ;
      const display3bTo   = display3bFrom + Math.floor( this.monitorSettingMap[3].limit / this.display3split );

      if (! this.showTomorrow ) {
        this.setDestinationWorkTasks(this.gridOptions3a.api, dispTaskList.slice(display3aFrom,display3aTo));
        this.setDestinationWorkTasks(this.gridOptions3b.api, dispTaskList.slice(display3bFrom,display3bTo));

      } else {

        const targetDateStr = "tomorrow";
        let dispTaskList2 = [];
        const destinationWorkTasks2 =  this.destinationWorkTasksMap[this.displayDates[targetDateStr]];
        if (destinationWorkTasks2) {

          for( let taskId of Object.keys(destinationWorkTasks2) ){
            let dispTask = destinationWorkTasks2[taskId];

            let isTarget = !dispTask.progress.valueMap ?
              false :
              this.activeListFlg ?
                dispTask.progress.valueMap.id !== '4' :
                dispTask.progress.valueMap.id === '4' ;

            if ( isTarget ) {
              dispTask.id = taskId;
              dispTaskList2.push(dispTask);
            }
          }
        }
        dispTaskList2.sort((a, b) => {
          // sort_orderでソート
          let comparison = 0;
          if (a.sort_order.valueMap.value > b.sort_order.valueMap.value) {
            comparison = 1;
          } else if (a.sort_order.valueMap.value < b.sort_order.valueMap.value) {
            comparison = -1;
          } else {
            // 第２ソートは オーダー時間
            if ( a.order_at.valueMap.value > b.order_at.valueMap.value ) {
              comparison = 1;
            } else if ( a.order_at.valueMap.value < b.order_at.valueMap.value ) {
              comparison = -1;
            }
          }
          return comparison ;
        });

        this.setDestinationWorkTasks(this.gridOptions3a.api, dispTaskList2.slice(display3aFrom,display3aTo));
        this.setDestinationWorkTasks(this.gridOptions3b.api, dispTaskList2.slice(display3bFrom,display3bTo));
      }
      if ( this.gridApi3a ) {
        this.gridApi3a.refreshCells({ force: true,  suppressFlash: true, });
        this.$nextTick(() => {
          this.onGridSizeChanged();
        });
      }
      if ( this.gridApi3b ) {
        this.gridApi3b.refreshCells({ force: true,  suppressFlash: true, });
        this.$nextTick(() => {
          this.onGridSizeChanged();
        });
      }

    },
    setDestinationWorkTasks(gridOptionsApi, newDestinationWorkTasks) {
      let lastIndex = -1;
      let removeNode = [];
      gridOptionsApi.forEachNode((rowNode, index) => {
        if (  newDestinationWorkTasks[index] ) {
          // update
          // rowNode.setData(newDestinationWorkTasks[index]);

          // agGridとstateのvalueMapを比較して、変化を検知した時だけupdate
          let valudMapDiffList = [];
          for ( let key of Object.keys(rowNode.data) ) {

            if ( !["docData"].includes(key) ) {
              if ( rowNode.data[key].valueMap && newDestinationWorkTasks[index][key].valueMap ) {
                const taskJsonAtGrid  = JSON.stringify(this.objectSort(rowNode.data[key].valueMap));
                const taskJsonAtState = JSON.stringify(this.objectSort(newDestinationWorkTasks[index][key].valueMap));
                if( taskJsonAtGrid !== taskJsonAtState ) {
                  valudMapDiffList.push( key );
                }
              } else if ( rowNode.data[key].valueMap === undefined && newDestinationWorkTasks[index][key].valueMap) {
                  valudMapDiffList.push( key );
              } else if ( rowNode.data[key].valueMap && newDestinationWorkTasks[index][key].valueMap === undefined ) {
                  valudMapDiffList.push( key );
              }
            }

          }

          if ( valudMapDiffList.filter(x => !!x).length > 0 ) {
            // update
            rowNode.setData(JSON.parse(JSON.stringify(newDestinationWorkTasks[index])));
          }
          lastIndex = index;
        } else {
          // prepare delete
          removeNode.push(rowNode.data);
        }
      });
      if (removeNode.length > 0) {
        gridOptionsApi.applyTransaction({ remove: removeNode });
      }
      if ( lastIndex + 1 < newDestinationWorkTasks.length  ) {
        // insert
        gridOptionsApi.applyTransaction({
          add: JSON.parse(JSON.stringify(newDestinationWorkTasks.slice(lastIndex + 1))),
        });
      }
    },

    refreshColumnDefs() {

      this.columnDefs1 = this.destinationWorkHeaders
      .filter(header => 
        // 下記条件にマッチする列は表示から除外する
        !(
             this.isReadOnlyDevice === true
                    &&  (
                             ( this.activeListFlg === true  && ["sort_order", "highlight", "first_line_at"].includes(header.columnKey) )
                          || ( this.activeListFlg === false && ["sort_order", "highlight"].includes(header.columnKey) )
                        )
          || this.isReadOnlyDevice === false 
                    &&  (
                             ( this.activeListFlg === true  && ["first_line_at"].includes(header.columnKey) )
                          || ( this.activeListFlg === false && ["sort_order", "highlight"].includes(header.columnKey) )
                        )
        )
      )
      .map(header => {
        let cellClassNameList = ['pm-ag-grid-cell'];
        if ( header.columnKey === "sort_order" ) { cellClassNameList.push('pm-ag-row-drag'); }
        if (
               (this.isReadOnlyDevice === true || this.isReadOnlyAccount === true ) 
            && !['caution_note', 'vessel'].includes(header.columnKey)   
        ) {
          cellClassNameList.push('pm-ag-grid-cell-readonly'); 
        }        
        return {
          field:      (header.columnKey === "sort_order" ? "sort_order.valueMap.order_at_string" : header.columnKey ),
          rowDrag:    (header.columnKey === "sort_order" ? true : false ),
          headerName: (["sort_order", "highlight"].includes(header.columnKey) ? "" : header.name ),
          width:      (["sort_order", "highlight"].includes(header.columnKey) ?  1 : header.width ? header.width : null),
          suppressMovable:       true,
          cellRendererFramework: "CellRendererItem",
          cellClass:             cellClassNameList.join(' '),
          cellRendererParams:    { displayNumber: 1 },
          cellClassRules: {
            'pm-highlight': params => params.node.data.highlight.valueMap.value == 1 && params.colDef && params.colDef.rowDrag === true,
          },

        };
      });

      if (this.gridApi1) {
        this.gridApi1.setColumnDefs(this.columnDefs1);
      }

      if (this.gridApi2a) {this.gridApi2a.setColumnDefs(this.filteredColumnDefs.slice(0).map(colDef => { colDef.cellRendererParams.displayNumber = 2; return colDef; })); }
      if (this.gridApi2b) {this.gridApi2b.setColumnDefs(this.filteredColumnDefs.slice(0).map(colDef => { colDef.cellRendererParams.displayNumber = 2; return colDef; })); }
      if (this.gridApi3a) {this.gridApi3a.setColumnDefs(this.filteredColumnDefs.slice(0).map(colDef => { colDef.cellRendererParams.displayNumber = 3; return colDef; })); }
      if (this.gridApi3b) {this.gridApi3b.setColumnDefs(this.filteredColumnDefs.slice(0).map(colDef => { colDef.cellRendererParams.displayNumber = 3; return colDef; })); }
    },

    objectSort(obj){

      // ソートする
      const entries = ( typeof obj === "object" && obj !== null) ? Object.entries(obj) : [obj];
      const sorted = entries.sort() ;

      for(let i in sorted){
        if ( Array.isArray(sorted[i]) && sorted[i][0] !== 'task_detail' ) {
          const val = sorted[i][1];
          if(typeof val === "object"){
            // valueを調べ、objectならsorted entriesに変換する
            sorted[i][1] = this.objectSort(val);
          }
        }
      }

      return sorted.filter(x => !!x && !!x[1]);
    },
    async updateGridCell(updateData) {

      const newTaskWithName = await this.mergeUpdateDataIntoTaskRecord(updateData);

      // agGrid1の対象行に直接更新。
      this.gridOptions1.api.forEachNode((rowNode, _) => {
        const taskId = rowNode.data[this.selectedColumnKey] ? rowNode.data[this.selectedColumnKey].taskId : null;
        if ( taskId === this.selectedTaskId ) {
          rowNode.setData(newTaskWithName);
        }
      });

    },
    onRowDragMove: function(evt){
      if (this.grabbedRowIndex == null ) {
        // ドラッグイベント開始時のみ行番号を記憶
        this.grabbedRowIndex = evt.overIndex;
      }
    },
    onRowDragEnd: function(evt) {
      if (this.grabbedRowIndex == evt.overIndex ) {
        // onRowDragMoveで記憶したドラッグイベント開始時の行番号と同じなら、何もしない。
        return;
      }
      this.grabbedRowIndex = null;

      this.$vs.loading();

      // ag-grid-vueの行入れ替えのイベント
      const sortOrderDataList = this.$refs.agGridTable1.getRowData().map((rowData,index) => {
        return {
          taskId: Object.values(rowData).find(x => x.taskId).taskId,
          enterprisePort: this.selectedPort,
          data:{ sort_order: index },
        };
      });

      sortOrderDataList.forEach(sortOrderData => { sortOrderData.enterprisePort = this.selectedPort; this.updateFirestoreDocument(sortOrderData)});

      this.$nextTick(() => {
        setTimeout(() => {
          this.$vs.loading.close();
        }, 1200); // TODO: 要タイミング調整
      });

    },

    onCellClicked: function(evt) {
      // セルがクリックされたら、vs-popupを起動

      if ( !['shipping_agency'].includes(evt.value.columnKey) ) {
        // 代理店はクリックを認識しない。
        this.setSelectedCell(evt.value);
      }

      const clickPopupColumnKeys = ['order_type', 'order_at', 'progress', 'progress_at', 'first_line_at', 'berth', 'vessel', 'vehicles', 'tug_boats', 'head_count', 'rope_boats', 'boardside_type', 'flag', 'bit', 'pilot', 'team_leader', 'caution_note', 'weather', 'previous', 'required_note'];
      if (!clickPopupColumnKeys.includes(evt.value.columnKey)) {
        return;
      }

      let destinationWorkHeader = this.destinationWorkHeaders.find(header => header.columnKey === evt.value.columnKey)
      this.popupTitle = evt.value.columnKey === 'vessel' ? '' : destinationWorkHeader ? destinationWorkHeader.name : true ;
      this.popupTaskId = evt.value.taskId;
      this.popupColumnKey = evt.value.columnKey;
      this.popupValueMap = evt.value.valueMap;
      this.clickX = evt.event.clientX;
      this.clickY = evt.event.clientY

      this.showPopupSync=true;

    },
    onChangeDate() {
      this.$vs.loading();
      setTimeout(() => {
        this.setSelectedDateDisplay1(this.selectedDisplayDateId);
        this.showPopupDate = false;
        this.$nextTick(() => {
          setTimeout(() => {
            this.$vs.loading.close();
          }, 1000);
        });
      }, 2000);
    },
    bindGridApi() {
      // 以下は、ag-grid-vueが実体化されたあとにセットする必要がある。v-show, v-ifで注意。
      this.gridApi1  = this.display1Active ? this.gridOptions1.api  : null;
      this.gridApi2a = this.display2Active ? this.gridOptions2a.api : null;
      this.gridApi2b = this.display2Active ? this.gridOptions2b.api : null;
      this.gridApi3a = this.display3Active ? this.gridOptions3a.api : null;
      this.gridApi3b = this.display3Active ? this.gridOptions3b.api : null;
    },
    getDisplay2split() {
      return this.monitorSettingMap[2] && this.monitorSettingMap[2].split ? this.monitorSettingMap[2].split : 2;
    },
    getDisplay3split() {
      return this.monitorSettingMap[3] && this.monitorSettingMap[3].split ? this.monitorSettingMap[3].split : 2;
    },

    onGridSizeChangedFromAgGrid() {
      const prepareSec = 8;  // ag-gridからの onGridSizeChanged() 呼び出しはページロード後 prepareSec秒まで。
      if ( this.pageLoadTime > 0 && this.pageLoadTime + prepareSec * 1000 > moment().valueOf() ) {
        this.onGridSizeChangedFromAgGridDebounce(this);
      } 
    },
    onGridSizeChangedFromAgGridDebounce: _.debounce((self) => {
      self.onGridSizeChanged();
    }, 3000),

    onGridSizeChanged(){
      // 自動リサイズ処理

      let paramObjList = [];
      if ( this.display1Active && this.monitorSettingMap[1]  ) {
        let paramObj1 = {
          gridApi: this.gridApi1,
          dispRecordCount: this.monitorSettingMap[1].limit,
          gridElement: this.$refs.agGridTable1.$el,
        };
        paramObjList.push(paramObj1);
      }
      if ( this.display2Active && this.monitorSettingMap[2] ) {
        let paramObj2a = {
          gridApi: this.gridApi2a,
          dispRecordCount: this.monitorSettingMap[2].limit / this.monitorSettingMap[2].split,
          gridElement: this.$refs.agGridTable2a.$el,
        };
        paramObjList.push(paramObj2a);
        if (  this.monitorSettingMap[2].split >= 2 ) {
          let paramObj2b = {
            gridApi: this.gridApi2b,
            dispRecordCount: this.monitorSettingMap[2].limit / this.monitorSettingMap[2].split,
            gridElement: this.$refs.agGridTable2b.$el,
          };
          paramObjList.push(paramObj2b);
        }
      }
      if ( this.display3Active && this.monitorSettingMap[3] ) {
        let paramObj3a = {
          gridApi: this.gridApi3a,
          dispRecordCount: this.monitorSettingMap[3].limit / this.monitorSettingMap[3].split,
          gridElement: this.$refs.agGridTable3a.$el,
        };
        if (  this.monitorSettingMap[3].split >= 2 ) {
          paramObjList.push(paramObj3a);
          let paramObj3b = {
            gridApi: this.gridApi3b,
            dispRecordCount: this.monitorSettingMap[3].limit / this.monitorSettingMap[3].split,
            gridElement: this.$refs.agGridTable3b.$el,
          };
          paramObjList.push(paramObj3b);

        }
      }


      let rowHeight = 32;
      let dispRecordCount = 25;

      setTimeout(() => {
        for (let paramObj of paramObjList) {
          dispRecordCount = paramObj.dispRecordCount;
          // agGridVueのHeader部分の座標サイズを取得
          const agHeaderViewport = paramObj.gridElement.querySelector(
            ".ag-header-viewport"
          );
          let agHeaderRect = agHeaderViewport.getBoundingClientRect();
          const clientHeight =  document.documentElement.clientHeight;
          const pmAgGridHeight = clientHeight - agHeaderRect.top + 0.5;  // agGrid全体の高さ
          const pmAgBodyHeight = clientHeight - agHeaderRect.bottom ;    // agGrid行データ表示領域の高さ
          paramObj.gridElement.style.height    = pmAgGridHeight + 'px'; 
          // ag-gridの高さ(height)を明記して描画領域を確保後、行高をセットする。
          // bodyの大きさから ２５行のタスクが収まるように行高を調整。
          rowHeight = Math.floor( pmAgBodyHeight / dispRecordCount );
          const agCenterContainer = paramObj.gridElement.querySelector(".ag-center-cols-clipper");
          if ( agCenterContainer ) {
            if ( this.scrollUnlock && dispRecordCount < paramObj.gridApi.getDisplayedRowCount() ) {
              // スクロール時は、body内側の height も再計算
              this.$nextTick(() => {
                const rowCount = paramObj.gridApi.getDisplayedRowCount();
                agCenterContainer.style.height = ( rowHeight * ( rowCount + 1 ) ) + 'px';
              });
            } else {
              agCenterContainer.style.height = null;
            }
          }
          paramObj.gridApi.forEachNode(function (rowNode) {
            rowNode.setRowHeight(rowHeight);
          });
          paramObj.gridApi.onRowHeightChanged();
          // 再描画
          paramObj.gridApi.sizeColumnsToFit();
          // フォントサイズの調整
          this.recalcFontSize(rowHeight, this);
        }
      }, 800 );
    },
    recalcFontSize: _.debounce((rowHeight, self) => {
       // フォントサイズを再設定して、rem指定のエレメントも拡大
      const dispFontRatioToRowHeight = 2.2; // 行の高さとフォントサイズの比率
       let rootElement = document.documentElement; //htmlのルート要素を取得
       rootElement.style.fontSize = Math.floor(rowHeight / dispFontRatioToRowHeight)  + "px" ;
       Vue.$log.debug("rowHeight, fontSize = ", rowHeight, rootElement.style.fontSize);
 
      self.setHeaderPositon();
    }, 300),

    setHeaderPositon() {
      if ( this.$refs.agGridTable1 ) {
        // 船舶の日本語/英表記の切り替え
        let agHeaderCellText = this.$refs.agGridTable1.$el.querySelectorAll(".ag-header-cell-text");
        const vesselHeader= this.destinationWorkHeaders.find(header => header.columnKey === "vessel");
        let foundVesselHeaderElement = Array.from(agHeaderCellText).find(el => el.innerText.trim().startsWith(vesselHeader.name));
        if ( foundVesselHeaderElement ) {
          foundVesselHeaderElement.innerHTML = vesselHeader.name + "　<span style='color:#2d9cdb;'>JP</span>/EN";

          const vesselRect =  foundVesselHeaderElement.getBoundingClientRect();
          let vesselOverlayCss = document.getElementById("vessel-header").style;
          vesselOverlayCss.top    = ( vesselRect.top    -15 ) + 'px';
          vesselOverlayCss.left   = ( vesselRect.left   -10 ) + 'px';
          vesselOverlayCss.height = ( vesselRect.height +30 ) + 'px';
          vesselOverlayCss.width  = ( vesselRect.width  +20 ) + 'px';
        }

        if ( this.isReadOnlyDevice !== true ){
          // パイロットのカラー表示切り替え
          const pilotHeader= this.destinationWorkHeaders.find(header => header.columnKey === "pilot");
          let foundPilotHeaderElement = Array.from(agHeaderCellText).find(el => el.innerText.trim().startsWith(pilotHeader.name));
          if ( foundPilotHeaderElement ) {
            const pilotRect =  foundPilotHeaderElement.getBoundingClientRect();
            let pilotOverlayCss = document.getElementById("pilot-header").style;
            pilotOverlayCss.top    = ( pilotRect.top    -15 ) + 'px';
            pilotOverlayCss.left   = ( pilotRect.left   -10 ) + 'px';
            pilotOverlayCss.height = ( pilotRect.height +30 ) + 'px';
            pilotOverlayCss.width  = ( pilotRect.width  +20 ) + 'px';
          }
        }
      }
    },
    toggleVesselNameJapaneseFlg() {
      if ( this.$refs.agGridTable1 ) {
        // 船舶の日本語/英表記の切り替え onmousedownイベントを上書き
        let agHeaderCellText = this.$refs.agGridTable1.$el.querySelectorAll(".ag-header-cell-text");
        const vesselHeader= this.destinationWorkHeaders.find(header => header.columnKey === "vessel");
        let foundVesselHeaderElement = Array.from(agHeaderCellText).find(el => el.innerText.trim().startsWith(vesselHeader.name));
        if ( foundVesselHeaderElement ) {
            const newVesselNameJapaneseFlg = !this.vesselNameJapaneseFlg;
            foundVesselHeaderElement.innerHTML = newVesselNameJapaneseFlg ?
              vesselHeader.name + "　<span style='color:#2d9cdb;'>JP</span>/EN":
              vesselHeader.name + "　JP/<span style='color:#2d9cdb;'>EN</span>";
            this.setVesselNameJapaneseFlg(newVesselNameJapaneseFlg);
        }
      }
    },
    togglePilotColorFlg() {
      if ( this.$refs.agGridTable1 ) {
        let agHeaderCellText = this.$refs.agGridTable1.$el.querySelectorAll(".ag-header-cell-text");
        if ( this.isReadOnlyDevice !== true ){
          // パイロットのカラー表示切り替え
          const pilotHeader= this.destinationWorkHeaders.find(header => header.columnKey === "pilot");
          let foundPilotHeaderElement = Array.from(agHeaderCellText).find(el => el.innerText.trim().startsWith(pilotHeader.name));
          if ( foundPilotHeaderElement ) {
            const pilotColorFlg = !this.pilotColorFlg;
            this.setPilotColorFlg(pilotColorFlg);
          }
        }
      }
    },

    async reconnectToServer() {
      // fireStoreのセッションが切れたと思われた場合に再接続するメソッド

      this.$vs.loading();
      this.onReconnect = true;

      // idトークンリフレッシュ。
      await authService
        .renewToken()  // 既存のIDトークンが生きている場合は何もしない。
        .then(() => { return authService.getIdToken(); })
        .then(t  => { this.$store.commit("SET_ID_TOKEN", { idToken: t }); });

      // firestoreリッスンを再接続
      await this.unsubscribeFirestore();
      await this.subscribeEventUpdate(this.selectedPort);
      await this.subscribeDestinationWorkTasks(this.selectedPort);

      this.$nextTick(() => {
        setTimeout(() => {
          this.onReconnect = false;
          this.$vs.loading.close();
        }, 3000);
      });
    },
    onScrollUnlock() {
      this.$vs.loading();
      setTimeout(() => {
        this.scrollUnlock = !this.scrollUnlock;
        this.redrawGrid();
        this.$nextTick(() => {
          setTimeout(() => {
            this.$vs.loading.close();
          }, 1000);
        });
      }, 2000);
    },
    onChangeActiveListFlg() {
      this.$vs.loading();
      setTimeout(() => {
        this.activeListFlg = !this.activeListFlg;
        this.refreshColumnDefs();
        this.redrawGrid();
        this.$nextTick(() => {
          setTimeout(() => {
            this.$vs.loading.close();
          }, 1000);
        });
      }, 2000);
    },
    detectReadOnlyDevice() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if(userAgent.indexOf('ipad') > -1
        || userAgent.indexOf('macintosh') > -1 && 'ontouchend' in document){
          // iPadの場合
          this.isReadOnlyDevice = true;
      }

      FireStoreService.getEnterpriseAccountSettings().then(settings => {
        if ( settings['port_master_read_only'] === true ) {
          this.isReadOnlyAccount = true;
        }
      });
      
    },
  },
  async created() {

    this.detectReadOnlyDevice();

    if (this.$route.params.displayId === '1') { this.display1Active = true; }
    if (this.$route.params.displayId === '2') { this.display2Active = true; }
    if (this.$route.params.displayId === '3') { this.display3Active = true; }

    // today,tomorrow,dayAfterTomorrow のセット
    await this.setTargetDates(this.selectedPort);

    // Firestore監視開始
    this.subscribeEventUpdate(this.selectedPort);
    this.subscribeDestinationWorkTasks(this.selectedPort);
  },
  mounted() {

    this.$vs.loading();

    this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", "portMaster");
    let routerViewClass = document.getElementsByClassName("router-view");
    routerViewClass[0].style.padding = "0.0rem";

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable1.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left =
        "-" + String(Number(header.style.transform.slice(11, -3)) + 9) + "px";
    }

    this.selectedDisplayDateId = this.selectedDateDisplay1;

    // 左上の現在時刻表示
    moment.locale("ja");
    setInterval(() => {
      this.dispDate = moment().local().format("YYYY/MM/DD(ddd) HH:mm");
    }, 1 * 1000);

    this.bindGridApi();

    document.body.oncontextmenu = function () {return false;}
  },
  beforeDestroy() {
    // call unsubscribe .
    this.unsubscribeFirestore();
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
html, body {
  font-family: $pm-font-family;
}
.ag-theme-material {
  font-family: $pm-font-family;
  font-size: inherit !important;
}

.v-nav-menu-swipe-area {
  display: none;
}

// ag-grid-vue のヘッダ部分
[dir=ltr] .ag-theme-material .ag-header-cell, [dir=ltr] .ag-theme-material .ag-header-group-cell {
  padding-left: 0;
  padding-right: 0;
  font-weight: normal;
  font-size: 60%;
  color: $pm-light-gray;
  background-color: #000000;
}

.pm-ag-grid-vue {
  /* padding-left:20px; */
  /* padding-right:20px; */
  padding-bottom: 0px;
}
.pm-ag-grid-vue-div2 {
  padding-left: 4px;
  padding-right: 4px;
}
.pm-ag-grid-vue-ipad-width {
  padding-left: 0px;
  padding-right: 0px;
}
.pm-ag-grid-cell {
  padding: 0 !important;
  margin: 0 auto;
  color: $pm-white;
  background-color: #333333;
  text-align: left;
  border: none !important;
}
.pm-ag-grid-cell-readonly {
  pointer-events: none;
}

[dir] .updated-cell {
  height:100%;
}

[dir] .pm-grouped-row {
    height:100%;
}

.pm-ag-row-drag {
  @extend .pm-ag-grid-cell;
  height:100%;
  div {
    height:100%;
    padding: 0 0.2rem 0 0.6rem;
    margin: 0 0.2rem 0 auto !important;
  }
}
.pm-highlight  {
  background-color: #65676A;
  border-top: 0.1rem solid #333333 !important;
}

.pm-highlight >  div {
  width: 100%;
  background-color: #65676A;
  margin: 0 !important;
}


#addon-port-master-destination-work-list {
  background-color: $pm-black;
  min-height: calc(100vh - 0px);

  .ag-row-drag {
    height: 100%;
  }
}

.pm-destination-work-top {
  margin-bottom: 1rem;
  width: 100%;
}

.pm-current-time {
  margin: 0.5rem 1.5rem 0 0.8rem;
  color: $pm-white;
  font-size: 120%;
}
.pm-display-date {
  border-radius: 1rem;
  padding: 0 1.5rem 0 1.0rem;
  margin-top: 0.4rem;
}

.pm-display-date-popup {
  .pm-display-date-item {
    margin:0.2rem;
  }
  .vs-popup {
    width: 40rem;
    background-color: $pm-white !important;
  }
  header {
    h3 {
      text-align: center;
      background-color: $pm-white;
    }
    i {
      border-radius: 2rem;
      border: 0.15rem solid $pm-black;
      font-weight: bold;
    }
    background-color: $pm-white;
  }
  .outer-area {
    padding: 1rem;
  }
  .save-button {
    margin: 0 1rem;
    width: 30%
  }
  .vs-popup--close {
    background-color: $pm-white !important;
    transform: translate(-10px,10px);
    &:hover {
      transform: translate(-10px,8px);
    }
  }
}

.pm-filter-control {
  padding: 0.3rem 0.7rem;
  color: $pm-dark-blue-navy;
}

.ag-header-viewport {
  background-color:$pm-black;
}
.ag-center-cols-viewport{
  background-color: $pm-black;
  overflow-x: hidden;
}
.ag-body-viewport {
  min-height: 100%;
  overflow-y: overlay !important;
  background-color:$pm-black;
}
.ag-header {
  min-height: 2rem !important;
}
.ag-header-row {
  height: 2rem !important;
  font-family: $pm-font-family;
  font-size: inherit !important;
}
.ag-header-cell-label {
  background-color:$pm-black;
}
.ag-header-cell-resize {
  background-color:$pm-black;
}
.ag-header-cell-text {
  padding-left: 0.25rem;
}
.ag-row .ag-cell {
  display: flex;
  align-items: center;
  border-top: 0.05rem solid #4F4F4F !important;
}
.ag-theme-material .ag-row {
  border: 0.03rem solid #000000; // 行間罫線
}

.ag-theme-material .ag-cell {
  line-height: 1rem;
}

.pm-cursor-pointer {
  cursor: pointer;
}

.pm-click-jacking {
  position: absolute;
  z-index: 999;
}

[dir=ltr] .ag-theme-material .ag-row-odd {
  background-color: black;
}

[dir=ltr] .ag-theme-material .ag-row {
  background-color: black;
}

</style>
